<template>
  <div class="card card-custom">
    <vDataLoader v-if="dataLoading" />

    <div class="table-container" style="padding-left: 2rem;" v-else>
      <div class="d-flex justify-content-between align-items-center pr-3">
      <h2 class="mb-4 mt-5">{{ notificationTitle }}</h2>
      <button
            ref="kt_save_add_another_company"
            class="btn btn-danger mr-3"
            @click="$router.push({ name: 'admin.notification' })"
            style="float: right"
          >
            <i class="fa fa-arrow-left"></i> Back
          </button>
        </div>
      <div style="margin-bottom: 1rem;">
        <strong>Total Delivered:</strong> {{ notifications.length }} |
        <strong>Read:</strong> {{ readCount }} |
        <strong>Unread:</strong> {{ unreadCount }}
      </div>

     
      <v-table :columns="columns">
        <tbody>
          <tr
            v-for="(item, index) in notifications"
            :key="index"
            class="hover-table"
          >
            <td>{{ item.client_name }}</td>
            <td>{{ capitalize(item.client_type) }}</td>
            <td>
              <span
                :style="{
                  color: item.is_read ? 'green' : 'red',
                  fontWeight: 'bold'
                }"
              >
                {{ item.is_read ? 'Read' : 'Not Read' }}
              </span>
            </td>
            <td>{{ item.read_at ? formatDate(item.read_at) : '—' }}</td>
            <td>{{ item.read_by || '—' }}</td>
          </tr>
        </tbody>
      </v-table>
    </div>
  </div>
</template>

<script>
import { GET_NOTIFICATION_REPORT } from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import vDataLoader from "@/components/frontend/spinner.vue";
import vTable from "@/includes/table/Datatable";

export default {
  components: {
    vDataLoader,
    vTable,
  },
  computed: {
    ...mapGetters(["currentUser"]),
    readCount() {
      return this.notifications.filter((n) => n.is_read).length;
    },
    unreadCount() {
      return this.notifications.filter((n) => !n.is_read).length;
    },
  },
  data() {
    return {
      columns: [
        { name: "client_name", label: "Client Name" },
        { name: "client_type", label: "Client Type" },
        { name: "is_read", label: "Read Status" },
        { name: "read_at", label: "Read At" },
        { name: "read_by", label: "Read By" },
      ],
      notifications: [],
      notificationTitle: "",
      dataLoading: false,
    };
  },
  created() {
    const id = this.$route.params.notification_id;
    if (id) {
      this.fetchNotificationReport(id);
      
    }
    
  },
  mounted() {
    this.$store.commit(SET_BREADCRUMB, [
      { id: 1, title: "Dashboard", route: "client.dashboard" },
      { id: 2, title: "Notification", route: "admin.notification" },
      { id: 3, title: "Viewer Report", route: "" },
    ]);
  },
  methods: {
    fetchNotificationReport(notification_id) {
      this.dataLoading = true;
      this.$store
        .dispatch(GET_NOTIFICATION_REPORT, { notification_id })
        .then((response) => {
          this.dataLoading = false;
          this.notifications = response.data || [];
          if (this.notifications.length > 0) {
            this.notificationTitle = this.notifications[0].notification_title;
          }
        })
        .catch(() => {
          this.dataLoading = false;
        });
    },
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      return d.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    capitalize(text) {
      if (!text) return "";
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
  },
};
</script>

<style scoped>
.hover-table:hover {
  background-color: #f9f9f9;
}
</style>
